import React from 'react';
import { DreamupFormModals } from '../../constants';
import PromptGuidelinesModal from './PromptGuidelinesModal';
import PointsModal from './PointsModal';
export const modalsRenderFunc = (modalType, popModal, params)=>{
    switch(modalType){
        case DreamupFormModals.POINTS:
            return /*#__PURE__*/ React.createElement(PointsModal, {
                onRequestClose: popModal
            });
        case DreamupFormModals.PROMPT_GUIDELINES:
            return /*#__PURE__*/ React.createElement(PromptGuidelinesModal, {
                onRequestClose: popModal,
                onConfirm: params.onConfirm
            });
        default:
            return null;
    }
};

//# sourceMappingURL=modalsRenderFunc.js.map